export default __webpack_public_path__ + "static/media/raw-galv-coil.fe38c14a.jpg";